//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    variants: {
      type: Array,
      required: true
    },

    scaleUp: {
      type: Boolean,
      default: false
    },

    activeSwatchIndex: {
      type: Number,
      default: 0
    }
  },

  methods: {
    selectSwatch (index) {
      this.$emit('update:activeSwatchIndex', index)
    }
  }
}
